import { Component, Input } from '@angular/core';
import { ContextualOptionModel } from 'src/app/models/contextual-menu-item.model';

@Component({
    selector: 'app-contextual-menu',
    standalone: false,
    templateUrl: './contextual-menu.component.html',
    styleUrl: './contextual-menu.component.css'
})
export class ContextualMenuComponent {
  
  @Input() x = 0;
  @Input() y = 0;
  @Input() date!: Date;
  @Input() options!: ContextualOptionModel[];

  onOptionClick(option: ContextualOptionModel) {
      if (option.action) {
          option.action();
      }
  }
}
